import axios from "axios"
import LayoutError from "components/LayoutError"
import { IErrorResponse } from "models/errors"
import React, { ReactNode, ErrorInfo } from "react"
import { RequirePermission } from "components/RequirePermission"
import { EOpusPermission } from "contexts/authorization/hooks/use-opus-permissions"

interface IBrokersBoundaryProps {
  children: ReactNode
}

interface IBrokersBoundaryState {
  hasError: boolean
  error?: Error
  errorInfo?: ErrorInfo
}

export class BrokersBoundary extends React.Component<
  IBrokersBoundaryProps,
  IBrokersBoundaryState
> {
  constructor(props: IBrokersBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): IBrokersBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState({ hasError: true, errorInfo, error })
  }

  render(): ReactNode {
    if (this.state.hasError) {
      if (axios.isAxiosError(this.state.error)) {
        const error = this.state.error as IErrorResponse

        return (
          <LayoutError
            title="Sorry, something went wrong."
            subTitle="Please contact support quoting the request ID below."
            requestID={error.response.data.requestID}
          />
        )
      } else {
        return (
          <LayoutError
            title="Sorry, something went wrong."
            subTitle="Please contact support if this error continues."
          />
        )
      }
    }

    return (
      <RequirePermission
        permissions={[
          `${EOpusPermission.aventusadmin}:true`,
          `${EOpusPermission.BrokerManagement}:true`
        ]}
      >
        {this.props.children}
      </RequirePermission>
    )
  }
}
